$(document).on('click','.the_drop_color>a',function(e){
    e.preventDefault();
    var target_page = $(this).attr("href");
    fetch(target_page + "?sections=main-product--buyable").then(res => res.json()).then((data) => {
        history.replaceState('','',target_page);
        var obj = $(data["main-product--buyable"]).find(".add-to-cart__button"),
            data_product_variant_id = obj.attr("data-product-variant-id"),
            stock_availability = obj.attr('data-cta-product-availability'),
            btn_contact_conciergerie = $(".product-item-cta.js-contact-conciergerie"),
            btn_contact_advisor = $(".product-item-cta.js-contact-advisor"),
            btn_add_to_cart = $(".add-to-cart__button"),
            sticky_add_to_cart = $('.sticky-add-to-cart');
        
        if($("#drop_wrapper").length){
            $("#drop_wrapper > .shopify-section:first-child .the_drop_color").html($(data["main-product--buyable"]).find(".the_drop_color").html());
            $("#drop_wrapper > .shopify-section:first-child .product__title").html($(data["main-product--buyable"]).find(".product__title").html());
            $("#drop_wrapper > .shopify-section:first-child .product__description").html($(data["main-product--buyable"]).find(".product__description").html());

            $("#drop_wrapper > .shopify-section:first-child .product__media img").each(function(index,val){
                var src = $(data["main-product--buyable"]).find(".product__media").find("img").eq(index).attr("src");
                var srcset = $(data["main-product--buyable"]).find(".product__media").find("img").eq(index).attr("srcset");
    
                $(this).attr("src",src);
                $(this).attr("srcset",srcset);
            });
            
            $("#drop_wrapper > .shopify-section:first-child .product-thumbnails img").each(function(index,val){
                var src = $(data["main-product--buyable"]).find(".product-thumbnails").find("img").eq(index).attr("src");
                var srcset = $(data["main-product--buyable"]).find(".product-thumbnails").find("img").eq(index).attr("srcset");
    
                $(this).attr("src",src);
                $(this).attr("srcset",srcset);
            });
    
            $("#drop_wrapper > .shopify-section:first-child .add-to-cart__button").attr("data-product-variant-id",$(data["main-product--buyable"]).find(".add-to-cart__button").attr("data-product-variant-id"));
    
        }
        if($("#dropcase_wrapper").length){
            $("#dropcase_wrapper > .shopify-section:first-child .the_drop_color").html($(data["main-product--buyable"]).find(".the_drop_color").html());
            $("#dropcase_wrapper > .shopify-section:first-child .product__title").html($(data["main-product--buyable"]).find(".product__title").html());
            $("#dropcase_wrapper > .shopify-section:first-child .product__description").html($(data["main-product--buyable"]).find(".product__description").html());
            $("#dropcase_wrapper > .shopify-section:first-child .product__price .fs-heading-4-base").html($(data["main-product--buyable"]).find(".fs-heading-4-base").html());

            $("#dropcase_wrapper > .shopify-section:first-child .add-to-cart__button").attr("data-product-variant-id",data_product_variant_id);
            sticky_add_to_cart.attr("data-product-variant-id",data_product_variant_id);
            $(".header__inner-sticky .header__right  .add-to-cart__button-header").attr("data-product-variant-id",data_product_variant_id);
            $(".desktop-to-cart .product-details .product-name,.mobile-to-cart .product-details .product-name").text($('.product__top .product__details .product__title').text().split(': ')[1]);
            $(".desktop-to-cart .product-details .product-price,.mobile-to-cart .product-details .product-price").text($('.product__price .fs-heading-4-base').text());
           
            $("#dropcase_wrapper > .shopify-section:first-child .product__media img").each(function(index,val){
                var src = $(data["main-product--buyable"]).find(".product__media").find("img").eq(index).attr("src");
                var srcset = $(data["main-product--buyable"]).find(".product__media").find("img").eq(index).attr("srcset");
    
                $(this).attr("src",src);
                $(this).attr("srcset",srcset);
                $(".desktop-to-cart .product-icon > img, .mobile-to-cart .product-icon > img").attr("src",src);
                $(".desktop-to-cart .product-icon > img, .mobile-to-cart .product-icon > img").attr("srcset",srcset);

            });

            $("#dropcase_wrapper > .shopify-section:first-child .product-thumbnails img").each(function(index,val){
                var src = $(data["main-product--buyable"]).find(".product-thumbnails").find("img").eq(index).attr("src");
                var srcset = $(data["main-product--buyable"]).find(".product-thumbnails").find("img").eq(index).attr("srcset");
    
                $(this).attr("src",src);
                $(this).attr("srcset",srcset);
                $(".desktop-to-cart .product-icon > img, .mobile-to-cart .product-icon > img").attr("src",src);
                $(".desktop-to-cart .product-icon > img, .mobile-to-cart .product-icon > img").attr("srcset",srcset);
            });
        }
         if(stock_availability == "true" && user_id || stock_availability == "true" && !user_id){
            btn_contact_conciergerie.addClass("d-none")
            btn_add_to_cart.removeClass("d-none")
            sticky_add_to_cart.removeClass('d-none')
            btn_contact_advisor.addClass("d-none")
        }else if(stock_availability == "false" && user_id){
            btn_contact_advisor.removeClass("d-none")
            btn_contact_conciergerie.addClass("d-none")
            btn_add_to_cart.addClass("d-none")
            sticky_add_to_cart.addClass('d-none')
        }else{
            btn_contact_conciergerie.removeClass("d-none")
            btn_add_to_cart.addClass("d-none")
            sticky_add_to_cart.addClass('d-none')
        }
    });
});